import { formatTimestampAsDateString } from "utils/format";
import { getRaffleTitle } from "views/win/userGeneratedRaffles/shared";
import { RafflesHistory } from "views/win/userGeneratedRaffles/types";

export const transformRafflesHistoryToProps = (raffle: RafflesHistory) => {
  return {
    raffleNumber: raffle.raffleOnChainId.toString(),
    raffleName: getRaffleTitle(
      raffle.prizes.filter((prize) => !!prize.token).map((prize) => ({ name: prize.token!.name }))
    ),
    totalEntriesBought: raffle.minimumEntries - raffle.remainingEntries,
    totalEntriesTarget: raffle.minimumEntries,
    numberParticipants: raffle.numOfParticipants,
    status: raffle.status,
    refundClaimed: raffle.refundClaimed,
    date: raffle.endedAt ? formatTimestampAsDateString(new Date(raffle.endedAt).getTime(), "LLL d, yyyy") : "-",
    isUserParticipant: !!raffle.participated,
    value: raffle.value,
  };
};
